import AxiosInstance from "./apiClient";

//Get All Ailment
export const getAllAilmentApi = async () => {
  try {
    const url = "ailments";
    const res = await AxiosInstance.get(url);
    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

//Get General Health or Symptom Question
export const getAilmentGroupQuestion = async ({ id, group }) => {
  try {
    const url = `ailment-qustions/${id}`;
    const res = await AxiosInstance.get(url, {
      group,
    });
    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

//Get AI Response
export const getAIRequestApi = async (id) => {
  try {
    const url = `user-submission/${id}`;
    const res = await AxiosInstance.get(url);
    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

//Get Fee Details
export const getFeeDetailsApi = async ({ name, body }) => {
  console.log("Fetching fee details for:", name);

  try {
    const url = `app-config/${name}`;
    console.log("Constructed URL for fee details:", url);

    const res = await AxiosInstance.get(url, {
      params: body,
    });
    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

export const checkSubmissionId = async (id) => {
  try {
    const url = `user-submission/check/${id}`;
    const res = await AxiosInstance.get(url);
    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

//Get Saved Cards
export const getSavedCardsApi = async () => {
  try {
    const url = "payments/cards/saved-cards";
    const res = await AxiosInstance.get(url);
    return res?.data;
  } catch (error) {
    console.log("Error fetching saved cards:", error);
    throw error;
  }
};

//Get User IP Address
export const getUserIpAddress = async () => {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    return data?.ip || "unknown";
  } catch (error) {
    console.log("Error fetching IP address:", error);
    return "unknown";
  }
};

//Get Purchase Details
export const getPurchaseDetailsApi = async (submissionId) => {
  try {
    const url = `user-submission/${submissionId}/purchase-details`;
    const res = await AxiosInstance.get(url);
    return res?.data;
  } catch (error) {
    console.log("Error fetching purchase details:", error);
    throw error;
  }
};

//Get Address List
export const getAddressListApi = async () => {
  try {
    const url = "address";
    const res = await AxiosInstance.get(url);
    return res?.data;
  } catch (error) {
    console.log("Error fetching address list:", error);
    throw error;
  }
};


